/**
 * Fireblocks integration API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AssetVaultValue {
  id?: string;
  total?: string;
  available?: string;
  pending?: string;
  lockedAmount?: string;
  totalStakedCPU?: string;
  totalStakedNetwork?: string;
  selfStakedCPU?: string;
  selfStakedNetwork?: string;
  pendingRefundCPU?: string;
  pendingRefundNetwork?: string;
}
